// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R\
import { mergeClasses, normalizeNumber } from 'util/commons';
import styles from './InputResourcesScannedTable.module.scss';
import { useTranslation } from 'react-i18next';
import { InputResourceQRData } from 'util/Types';
import { CustomCheckBox } from 'components/atoms/CustomCheckbox';
import { useMemo } from 'react';

type InputResourcesScannedTableProps = {
  data?: Record<string, InputResourceQRData>;
  checkedIds?: string[];
  setCheckedIds?: (ids: string[]) => void;
};

const InputResourcesScannedTable: React.FC<InputResourcesScannedTableProps> = ({
  data = {},
  checkedIds = [],
  setCheckedIds,
}) => {
  const { t } = useTranslation();

  const processingObjectIds = useMemo(
    () =>
      Object.values(data)
        .map(({ resources }) =>
          resources.map((item) => item.processingObjectId)
        )
        .flat(),
    [data]
  );

  const handleCheckAll = () => {
    if (checkedIds.length === processingObjectIds.length) {
      setCheckedIds?.([]);
    } else {
      setCheckedIds?.(processingObjectIds);
    }
  };

  const handleCheck = (id: string) => {
    if (checkedIds.includes(id)) {
      setCheckedIds?.(checkedIds.filter((item) => item !== id));
    } else {
      setCheckedIds?.([...checkedIds, id]);
    }
  };

  const renderDataList = () => {
    if (!Object.keys(data).length) {
      return (
        <tr>
          <td colSpan={5} className={styles.noData}>
            {t('messages.M_008')}
          </td>
        </tr>
      );
    }

    return Object.values(data)
      .map(({ resources, ...rest }) =>
        resources.map((resource) => ({
          ...rest,
          ...resource,
        }))
      )
      .flat()
      .map((resource) => (
        <tr key={resource.processingObjectId}>
          <td>
            <CustomCheckBox
              id={`scanned-${resource.processingObjectId}`}
              checked={checkedIds.includes(resource.processingObjectId)}
              onChange={() => handleCheck(resource.processingObjectId)}
            />
          </td>
          <td>{resource.processingObjectId}</td>
          <td>{resource.deliveryFromSite.name}</td>
          <td>{resource.wasteUnit?.name}</td>
          <td>
            {normalizeNumber({
              value: resource.remainingWeight,
            })}{' '}
            kg
          </td>
        </tr>
      ));
  };

  return (
    <table className={mergeClasses('primary-table', styles.scannedTable)}>
      <thead>
        <tr>
          <th>
            <CustomCheckBox
              id="scanned-checkAll"
              checked={
                processingObjectIds.length > 0 &&
                checkedIds.length === processingObjectIds.length
              }
              onChange={handleCheckAll}
              disabled={!processingObjectIds.length}
            />
          </th>
          <th>{t('pre_regist_resource_select.scan_modal.resource_id')}</th>
          <th>{t('pre_regist_resource_select.scan_modal.site_name')}</th>
          <th>{t('pre_regist_resource_select.scan_modal.item_name')}</th>
          <th>{t('pre_regist_resource_select.scan_modal.weight')}</th>
        </tr>
      </thead>

      <tbody>{renderDataList()}</tbody>
    </table>
  );
};

export default InputResourcesScannedTable;
